import React from 'react';

const SalesReport = () => {
    return (
        <div>
            <h2>Sales Report</h2>
            {/* 这里可以放表格或列表组件 */}
        </div>
    );
};

export default SalesReport;
